import type { ReactNode } from 'react'
import Header from './Header'

interface MainLayoutProps {
  children: ReactNode
}

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background-secondary)' }}>
      <Header />
      <div className="relative">
        <div className="hero-blob"/>
        <main className="container mx-auto px-4 py-8">
          {children}
        </main>
      </div>
    </div>
  )
}
